import {jQuery as $, lodash as _} from 'lib/shim';



const SELECTOR = '.organism-footer';



class OrganismFooter {

	constructor(app, $element){
		if( !$.isSet($element.dataDuo('primed')) ){
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;

			this._$footerMetaHolder = this._$element.find('.footer-meta-holder').first();
			this._$languageButtons = this._$footerMetaHolder.find('.language-menu-button');
			this._$footerLanguagesWrapper = this._$footerMetaHolder.find('.footer-languages-wrapper').first();

			this._prime();
		}

		return $element;
	}



	_prime(){
		let _this_ = this;

		this._$languageButtons.each(function () {
			let $currentButton = $(this);
			let timeout = null;

			$currentButton.on('click', function (e) {
				e.preventDefault();


				if (!$currentButton.hasClass('active')) {
					$currentButton.addClass('active');

					_this_._$footerLanguagesWrapper.removeClass('hidden');

					let offsetHeaderTop = $('header.sticky-header').height();

					$("html, body").delay(250).animate({scrollTop: $('.footer-languages-wrapper').offset().top - offsetHeaderTop }, 500);

				} else {
					clearTimeout(timeout);
					$currentButton.removeClass('active');
					_this_._$footerLanguagesWrapper.addClass('hidden');
				}
			});


			$(window).on('breakpointchange.app', (e, oldBreakpoint, newBreakpoint) => {
				if( $currentButton.hasClass('active') ){
					$currentButton.triggerHandler('click');
				}
			});
		});
	}
}



export function init(app){
	let $elements = $();

	$(SELECTOR).each(function(){
		let $this = $(this);

		$elements = $elements.add(new OrganismFooter(app, $this));
	});

	return $elements;
}
